
import { useState } from "react";
import { FilledButton, OutlinedButton } from "../../common/Button";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { IFreelancer } from "../../../data_models/freelancer";
import Lightbox from "../../common/Lightbox";
import TextInputField from "../../common/TextInputField";
import MultiTextSelect from "../../common/MultiTextSelect";


interface EditSocialLinksFreelancerProps {
    onClose: () => void;
}

export const EditSocialLinksFreelancer: React.FC<EditSocialLinksFreelancerProps> = ({ onClose }) => {

    const [loading, setLoading] = useState(false);
    const { currentUser, updateCurrentUser } = useCurrentUser();

    const [linkedIn, setLinkedin] = useState((currentUser as IFreelancer)?.socialLinks?.linkedin || '');
    const [facebook, setFacebook] = useState((currentUser as IFreelancer)?.socialLinks?.facebook || '');
    const [x, setX] = useState((currentUser as IFreelancer)?.socialLinks?.x || '');
    const [instagram, setInstagram] = useState((currentUser as IFreelancer)?.socialLinks?.instagram || '');
    const [github, setGithub] = useState((currentUser as IFreelancer)?.socialLinks?.github || '');
    const [youtube, setYoutube] = useState((currentUser as IFreelancer)?.socialLinks?.youtube || '');
    const [stackoverflow, setStackoverflow] = useState((currentUser as IFreelancer)?.socialLinks?.stackoverflow || '');
    const [pinterest, setPinterest] = useState((currentUser as IFreelancer)?.socialLinks?.pinterest || '');
    const [tiktok, setTiktok] = useState((currentUser as IFreelancer)?.socialLinks?.tiktok || '');
    const [reddit, setReddit] = useState((currentUser as IFreelancer)?.socialLinks?.reddit || '');
    const [behance, setBehance] = useState((currentUser as IFreelancer)?.socialLinks?.behance || '');
    const [dribbble, setDribbble] = useState((currentUser as IFreelancer)?.socialLinks?.dribbble || '');
    const [websites, setWebsites] = useState((currentUser as IFreelancer)?.socialLinks?.websites || []);

    const checkIfValid = () => {
        let valid = true;

        return valid;
    }

    const onSubmit = async () => {

        const valid = checkIfValid();
        if (!valid) return;

        setLoading(true);

        try {

            const updateObj: IFreelancer = {
                socialLinks: {
                    linkedin: linkedIn,
                    facebook: facebook,
                    x: x,
                    instagram: instagram,
                    github: github,
                    youtube: youtube,
                    stackoverflow: stackoverflow,
                    pinterest: pinterest,
                    tiktok: tiktok,
                    reddit: reddit,
                    behance: behance,
                    dribbble: dribbble,
                    websites: websites,
                }
            }
            await updateCurrentUser(updateObj);
        } catch (error: any) {
        } finally {
            setLoading(false);
            onClose();
        }
    }

    return (
        <Lightbox
            content={
                <div className="flex flex-col space-y-6 w-full" >
                    <h4>Update Personal Information</h4>

                    {/* Linked In */}
                    <TextInputField
                        type="text"
                        id="linkedIn"
                        label="LinkedIn"
                        placeholder="LinkedIn Url"
                        value={linkedIn}
                        onChange={(e) => setLinkedin(e.target.value)}
                    />

                    {/* Facebook */}
                    <TextInputField
                        type="text"
                        id="facebook"
                        label="Facebook"
                        placeholder="Facebook Url"
                        value={facebook}
                        onChange={(e) => setFacebook(e.target.value)}
                    />

                    {/* X */}
                    <TextInputField
                        type="text"
                        id="x"
                        label="X"
                        placeholder="X Url"
                        value={x}
                        onChange={(e) => setX(e.target.value)}
                    />

                    {/* Instagram */}
                    <TextInputField
                        type="text"
                        id="instagram"
                        label="Instagram"
                        placeholder="Instagram Url"
                        value={instagram}
                        onChange={(e) => setInstagram(e.target.value)}
                    />

                    {/* Github */}
                    <TextInputField
                        type="text"
                        id="github"
                        label="Github"
                        placeholder="Github Url"
                        value={github}
                        onChange={(e) => setGithub(e.target.value)}
                    />

                    {/* Youtube */}
                    <TextInputField
                        type="text"
                        id="youtube"
                        label="Youtube"
                        placeholder="Youtube Url"
                        value={youtube}
                        onChange={(e) => setYoutube(e.target.value)}
                    />

                    {/* Stackoverflow */}
                    <TextInputField
                        type="text"
                        id="stackoverflow"
                        label="Stackoverflow"
                        placeholder="Stackoverflow Url"
                        value={stackoverflow}
                        onChange={(e) => setStackoverflow(e.target.value)}
                    />

                    {/* Pinterest */}
                    <TextInputField
                        type="text"
                        id="pinterest"
                        label="Pinterest"
                        placeholder="Pinterest Url"
                        value={pinterest}
                        onChange={(e) => setPinterest(e.target.value)}
                    />

                    {/* Tiktok */}
                    <TextInputField
                        type="text"
                        id="tiktok"
                        label="Tiktok"
                        placeholder="Tiktok Url"
                        value={tiktok}
                        onChange={(e) => setTiktok(e.target.value)}
                    />


                    {/* Reddit */}
                    <TextInputField
                        type="text"
                        id="reddit"
                        label="Reddit"
                        placeholder="Reddit Url"
                        value={reddit}
                        onChange={(e) => setReddit(e.target.value)}
                    />

                    {/* Behance */}
                    <TextInputField
                        type="text"
                        id="behance"
                        label="Behance"
                        placeholder="Behance Url"
                        value={behance}
                        onChange={(e) => setBehance(e.target.value)}
                    />

                    {/* Dribbble */}
                    <TextInputField
                        type="text"
                        id="dribbble"
                        label="Dribbble"
                        placeholder="Dribbble Url"
                        value={dribbble}
                        onChange={(e) => setDribbble(e.target.value)}
                    />

                    {/* Other */}
                    <MultiTextSelect
                        elements={websites}
                        setElements={setWebsites}
                        label="Other Websites"
                    />



                    <div className="flex flex-row justify-end w-full space-x-2">

                        <OutlinedButton onClick={onClose}>Cancel</OutlinedButton>
                        <FilledButton
                            isLoading={loading}
                            onClick={onSubmit}>Submit</FilledButton>
                    </div>
                </div>}
            onClose={onClose}
        />

    );
}

